/* JC-EVO 09/24/2026: adds a "Read more" link under the review text of every Stamped carousel card and a
   "View all" link after the carousel's rating summary: on product pages it jumps to the product's own
   Stamped reviews list further down; elsewhere it opens /pages/rkin-reviews.
   Cards are rendered by Stamped after load, so a light, frame-throttled observer picks them up (including carousels
   re-rendered in the theme editor).
   JC-EVO 09/27/2026 (Eric: "Read more" did not open): Stamped's review link (stamped.io/go/…) now returns 404, so
   "Read more" and the review title open the reviewed product's page at its reviews (#stamped-main-widget). The
   original Stamped link is kept in data-jc-go; the product-link script below reads its review ID from there.
   JC-EVO 10/01/2026 (PSI "Links do not have descriptive text", 30 x "Read more"): cards already show the full review, so the
   link's job is "see all reviews for this product". Visible text "See all reviews" (jc.reviews.see_all_reviews) plus a
   visually hidden " of <product name on the card>" (jc.reviews.see_all_reviews_of, placeholder [product]) so every link's
   text is unique and starts with the visible words (WCAG 2.5.3). Horizon's own .visually-hidden class; no aria-label. */
(function () {
  var WIDGET = '#stamped-reviews-widget[data-widget-type="carousel"]';
  var SEL = WIDGET + ' .block';
  // JC-EVO 09/28/2026 (/es): link texts come from theme locale keys jc.reviews.* via data attributes on this file's
  // <script> tag (sections/footer-group.json, footer integrations custom liquid); English is the fallback.
  var TAG = document.currentScript;
  var TXT = {
    viewAll: (TAG && TAG.getAttribute('data-view-all')) || 'View all',
    viewAllContext: (TAG && TAG.getAttribute('data-view-all-context')) || '',
    readMore: (TAG && TAG.getAttribute('data-read-more')) || 'See all reviews',
    readMoreOf: (TAG && TAG.getAttribute('data-read-more-of')) || 'of [product]',
    readFullNamed: (TAG && TAG.getAttribute('data-read-full-named')) || "Read [name]'s full review",
    readFull: (TAG && TAG.getAttribute('data-read-full')) || 'Read the full review',
    showLess: (TAG && TAG.getAttribute('data-show-less')) || 'Show less'
  };
  // Product pages: "View all" scrolls to the product's own Stamped reviews. Scripted rather than a plain #anchor:
  // Horizon scrolls .page-wrapper on desktop and the product-tabs scroll spacer and late-loading images move the
  // target, so re-check twice while the page settles.
  function jumpToReviews(e) {
    var t = document.getElementById('stamped-main-widget');
    if (!t) return;
    e.preventDefault();
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var off = function () { return t.getBoundingClientRect().top - (parseFloat(getComputedStyle(t).scrollMarginTop) || 0); };
    t.scrollIntoView({ behavior: calm ? 'instant' : 'smooth', block: 'start' });
    [900, 2000].forEach(function (ms) {
      setTimeout(function () { if (Math.abs(off()) > 40) t.scrollIntoView({ behavior: 'instant', block: 'start' }); }, ms);
    });
  }
  // JC-EVO 10/06/2026 (Eric: Lighthouse speed, no visible change): one pass reads every card's clamp
  // once, then writes. A body mutation used to rescan every card and flush layout for each.
  function enhance() {
    var widgets = document.querySelectorAll(WIDGET);
    for (var i = 0; i < widgets.length; i++) pass(widgets[i], null);
  }
  // 10/01/2026 (Eric): the card clamps the review text (custom-theme.css, -webkit-line-clamp 7). When a card's text is
  // actually cut off (measured: scrollHeight > clientHeight + 1), a real button right after it reads "Read <first name>'s
  // full review" and toggles .jc-review-open on that card only (CSS removes the clamp), aria-expanded + aria-controls; the
  // visible text is the accessible name. Re-measured when that card's text, font or width changes; while open
  // the button stays ("Show less"). Nothing is written when a value is already right (no observer loop).
  var uid = 0;
  var fontGen = 0, sizeGen = 0, rz = 0, timer = 0, pending = [], watched = [];
  // JC-EVO 10/06/2026 (Eric: Lighthouse speed, no visible change): own writes are not filtered. The pass
  // writes only when a value differs, so the mutation those writes queue schedules one follow-up that
  // changes nothing and the chain stops. jcPasses counts pass() calls for that check.
  function dropNode(el) {
    if (!el || !el.parentNode) return;
    el.parentNode.removeChild(el);
  }
  function buttonLabel(b, open) {
    var name = firstName(b);
    return open ? TXT.showLess : name && TXT.readFullNamed.indexOf('[name]') !== -1 ? TXT.readFullNamed.replace('[name]', function () { return name; }) : TXT.readFull;
  }
  function firstName(b) {
    var au = b.querySelector('.stamped-reviews-author');
    var w = au ? au.textContent.trim().split(/\s+/)[0] || '' : '';
    w = w.replace(/^[^\p{L}]+|[^\p{L}]+$/gu, '');
    if (w.length < 2 || /^anonymous$/i.test(w)) return '';
    return w.split('-').map(function (s) { return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }).join('-');
  }
  function keyFor(b, open, text) {
    var author = b.querySelector('.stamped-reviews-author');
    return fontGen + '|' + sizeGen + '|' + (open ? '1' : '0') + '|' + text + '|' + (author ? author.textContent : '');
  }
  function remember(snap, btnOn) {
    snap.b.jcMeasureKey = keyFor(snap.b, snap.open, snap.text);
    snap.b.jcMeasureBlock = snap.block;
    snap.b.jcMeasureBtn = btnOn ? 1 : 0;
  }
  function prep(b) {
    var msg = b.querySelector('.stamped-reviews-message');
    var block = msg && msg.querySelector('.stamped-reviews-message-block');
    var extra = b.querySelectorAll('.jc-review-more');
    var open = b.classList.contains('jc-review-open');
    var text = block ? block.textContent : '';
    var dropOpen = !!(block && open && (b.jcOpenBlock !== block || b.jcOpenText !== block.textContent));
    var openNow = open && !dropOpen;
    var hit = !!(block && !dropOpen && extra.length <= 1 && b.jcMeasureBlock === block && b.jcMeasureBtn === (extra.length ? 1 : 0) && b.jcMeasureKey === keyFor(b, openNow, text));
    return { b: b, msg: msg, block: block, btn: extra[0] || null, extra: extra, open: openNow, dropOpen: dropOpen, text: text, hit: hit, overflow: false, laidOut: true, done: false };
  }
  function applyPre(snap) {
    if (snap.hit) return;
    var extra = snap.extra, btn = snap.btn, b = snap.b;
    for (var j = 1; j < extra.length; j++) dropNode(extra[j]);
    if (!snap.block) {
      if (btn) dropNode(btn);
      b.classList.remove('jc-review-open');
      b.jcMeasureKey = '';
      b.jcMeasureBlock = null;
      b.jcMeasureBtn = 0;
      snap.done = true;
      return;
    }
    if (snap.dropOpen) {
      b.classList.remove('jc-review-open');
      snap.open = false;
    }
  }
  // Cache stores geometry only. A hit still reconciles the button's identity, label, aria-expanded and
  // aria-controls. Markup that keeps the same textContent clears the key before this runs, so overflow is re-read.
  function applyPost(snap) {
    if (snap.done || !snap.block || !snap.msg) return;
    var b = snap.b, msg = snap.msg, block = snap.block, open = snap.open, btn = snap.btn;
    var want = open || (snap.hit ? b.jcMeasureBtn === 1 : !!snap.overflow);
    if (!snap.hit && snap.laidOut === false && !open) want = false;
    if (!want) {
      if (btn) dropNode(btn);
      if (!snap.hit) { if (snap.laidOut) remember(snap, false); else b.jcMeasureKey = ''; }
      return;
    }
    if (!block.id || document.getElementById(block.id) !== block) block.id = 'jc-review-text-' + (++uid) + '-' + Math.random().toString(36).slice(2, 7);
    if (!btn || !btn.parentNode) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jc-review-more';
      snap.btn = btn;
      msg.insertAdjacentElement('afterend', btn);
    }
    if (btn.getAttribute('aria-controls') !== block.id) btn.setAttribute('aria-controls', block.id);
    var exp = open ? 'true' : 'false';
    if (btn.getAttribute('aria-expanded') !== exp) btn.setAttribute('aria-expanded', exp);
    var label = buttonLabel(b, open);
    if (btn.textContent !== label) btn.textContent = label;
    if (msg.nextElementSibling !== btn) msg.insertAdjacentElement('afterend', btn);
    if (!snap.hit && snap.laidOut !== false) remember(snap, true);
  }
  function expandAll(list) {
    var snaps = [];
    var retry = false;
    for (var i = 0; i < list.length; i++) snaps.push(prep(list[i]));
    for (var p = 0; p < snaps.length; p++) applyPre(snaps[p]);
    // JC-EVO 10/06/2026 (Eric: Lighthouse speed, no visible change): geometry reads for every closed card
    // run here, with no DOM writes between them, so the browser flushes layout once per pass.
    for (var r = 0; r < snaps.length; r++) {
      var s = snaps[r];
      if (s.hit || s.done || !s.block || s.open) continue;
      s.overflow = s.block.scrollHeight > s.block.clientHeight + 1;
      s.laidOut = s.block.clientWidth > 0;
      if (!s.laidOut) retry = true;
    }
    for (var wri = 0; wri < snaps.length; wri++) applyPost(snaps[wri]);
    return retry;
  }
  function expand(b) { expandAll([b]); }
  // one delegated listener (survives re-rendered or cloned cards); the button keeps focus because it is never replaced
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SEL + ' .jc-review-more');
    if (!btn) return;
    var c = btn.closest('.block');
    var block = c.querySelector('.stamped-reviews-message-block');
    if (c.classList.toggle('jc-review-open')) { c.jcOpenBlock = block; c.jcOpenText = block && block.textContent; } else { c.jcOpenBlock = null; c.jcOpenText = null; }
    expand(c);
  });
  function remeasure() { clearTimeout(rz); rz = setTimeout(function () { sizeGen++; enhance(); }, 150); }
  addEventListener('resize', remeasure, { passive: true });
  addEventListener('orientationchange', remeasure, { passive: true });
  if (document.fonts) { // late web-font swaps change line breaks without a DOM mutation
    if (document.fonts.ready) document.fonts.ready.then(function () { fontGen++; remeasure(); });
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { fontGen++; remeasure(); });
  }
  // 10/01/2026: every pass reconciles each card from ONE source, the card's product link as resolved by the product-link
  // script below (.stamped-reviews-product-title / .stamped-reviews-image link with a /products/ path; that script removes
  // the href of unknown products). The review title (Stamped's stamped.io/go link, kept in data-jc-go) follows it. The
  // "See all reviews" link exists only while the card has both that link and a product name, so its text is never generic;
  // it is created, re-pointed or removed only here, and nothing is written when a value is already right (no observer loop).
  // 10/03/2026 (Lighthouse crawlable-anchors): an <a> whose href was removed is no longer a link; role=none says so to
  // crawlers and assistive tech. data-jc-inert keeps the original role, restored when a real href comes back. Tab order
  // (tabindex / aria-hidden) stays with the empty-title logic above.
  function inert(a, on) {
    var was;
    if (on) {
      if (a.hasAttribute('href')) a.removeAttribute('href');
      if (!a.hasAttribute('data-jc-inert')) a.setAttribute('data-jc-inert', JSON.stringify(a.getAttribute('role')));
      if (a.getAttribute('role') !== 'none') a.setAttribute('role', 'none');
    } else if (a.hasAttribute('data-jc-inert')) {
      try { was = JSON.parse(a.getAttribute('data-jc-inert')); } catch (e) { was = null; }
      if (typeof was === 'string' && was) a.setAttribute('role', was); else a.removeAttribute('role');
      a.removeAttribute('data-jc-inert');
    }
  }
  function card(b) {
    var prod = b.querySelector('.stamped-reviews-product-title a[href^="/products/"], .stamped-reviews-image a[href^="/products/"]');
    var pt = b.querySelector('.stamped-reviews-product-title');
    var pname = pt ? pt.textContent.replace(/\s+/g, ' ').trim() : '';
    var msg = b.querySelector('.stamped-reviews-message');
    var href = prod ? prod.getAttribute('href').split('#')[0] + '#stamped-main-widget' : null;
    var title = b.querySelector('.stamped-reviews-title a');
    if (title) {
      var th = title.getAttribute('href') || '';
      if (/^https:\/\/stamped\.io\/go\//.test(th)) title.setAttribute('data-jc-go', th);
      if (title.hasAttribute('data-jc-go')) {
        if (href) { if (th !== href) title.setAttribute('href', href); inert(title, false); }
        else inert(title, true);
      }
    }
    var a = b.querySelector('.jc-read-more');
    if (!href || !pname || !msg) { if (a) dropNode(a); return; }
    if (!a) {
      a = document.createElement('a');
      a.className = 'jc-read-more';
      msg.insertAdjacentElement('afterend', a);
    }
    if (a.getAttribute('href') !== href) a.setAttribute('href', href);
    // Visible words stay a leading text node so fixing them does not rebuild the hidden product phrase.
    var lead = a.firstChild;
    if (!lead || lead.nodeType !== 3) a.insertBefore(document.createTextNode(TXT.readMore), a.firstChild);
    else if (lead.nodeValue !== TXT.readMore) lead.nodeValue = TXT.readMore;
    // exactly one visually hidden " of <product name>" after the visible words (Horizon's .visually-hidden)
    var want = TXT.readMoreOf.indexOf('[product]') !== -1 ? ' ' + TXT.readMoreOf.replace('[product]', function () { return pname; }) : '';
    var hid = a.querySelectorAll('.visually-hidden');
    for (var j = 1; j < hid.length; j++) dropNode(hid[j]);
    var h = hid[0];
    if (!want) { if (h) dropNode(h); return; }
    if (!h) { h = document.createElement('span'); h.className = 'visually-hidden'; a.appendChild(h); }
    if (h.textContent !== want) h.textContent = want;
  }
  function emptyTitle(ea) {
    var named = ea.textContent.trim() || ea.getAttribute('aria-label') || ea.getAttribute('title') || ea.querySelector('img[alt]:not([alt=""]),[aria-label]');
    var marked = ea.hasAttribute('data-jc-empty');
    if (!named && !marked) {
      ea.setAttribute('data-jc-empty', JSON.stringify([ea.getAttribute('tabindex'), ea.getAttribute('aria-hidden')]));
      ea.setAttribute('tabindex', '-1');
      ea.setAttribute('aria-hidden', 'true');
    } else if (named && marked) {
      var was = []; try { was = JSON.parse(ea.getAttribute('data-jc-empty')) || []; } catch (e) {}
      ea.removeAttribute('data-jc-empty');
      if (was[0] === null || was[0] === undefined) ea.removeAttribute('tabindex'); else ea.setAttribute('tabindex', was[0]);
      if (was[1] === null || was[1] === undefined) ea.removeAttribute('aria-hidden'); else ea.setAttribute('aria-hidden', was[1]);
    }
  }
  // JC-EVO 10/07/2026 (RC10 a11y, Eric): retain visible words and append review context once.
  function viewAllText(v) {
    if (v.textContent === TXT.viewAll + TXT.viewAllContext && (!TXT.viewAllContext || v.querySelector('.visually-hidden'))) return;
    v.textContent = TXT.viewAll;
    if (!TXT.viewAllContext) return;
    var span = document.createElement('span');
    span.className = 'visually-hidden'; span.textContent = TXT.viewAllContext; v.appendChild(span);
  }
  function viewAll(widget) {
    var subs = widget.querySelectorAll('.stamped-carousel-subtitle');
    var main = document.getElementById('stamped-main-widget');
    var href = main ? '#stamped-main-widget' : '/pages/rkin-reviews';
    for (var j = 0; j < subs.length; j++) {
      var v = subs[j].querySelector('.jc-view-all');
      if (!v) {
        v = document.createElement('a');
        v.className = 'jc-view-all';
        v.setAttribute('href', href);
        viewAllText(v);
        if (main) { v.addEventListener('click', jumpToReviews); v.jcJump = 1; }
        subs[j].appendChild(v);
        continue;
      }
      if (main && !v.jcJump) { v.addEventListener('click', jumpToReviews); v.jcJump = 1; }
      if (v.getAttribute('href') !== href) v.setAttribute('href', href);
      viewAllText(v);
    }
  }
  function alive(n) { return !!(n && n.ownerDocument && n.ownerDocument.documentElement.contains(n)); }
  // JC-EVO 10/07/2026 (RC10 a11y, Eric): each Stamped scroller owns its visibility observer.
  function jcVisibleCards(root, selector, motion) {
    if (!root || !window.IntersectionObserver || !window.MutationObserver) return null;
    var observed = [], frame = 0, until = 0;
    // JC-EVO 10/07/2026 (RC10 a11y, Eric): retain focus; reconcile once after resize.
    var resizeTimer = 0, focusTimer = 0, sizeObserver = null;
    function sync() {
      if (!root.isConnected) { stop(); return; }
      var box = root.getBoundingClientRect();
      var left = box.left + root.clientLeft, top = box.top + root.clientTop;
      var right = left + root.clientWidth, bottom = top + root.clientHeight;
      var cards = root.querySelectorAll(selector);
      for (var i = 0; i < observed.length; i++) {
        if (!root.contains(observed[i])) { observer.unobserve(observed[i]); observed.splice(i--, 1); }
      }
      for (var j = 0; j < cards.length; j++) {
        var card = cards[j];
        // Marquee copies stay hidden; only the originals belong to this observer.
        if (card.closest('.logo-slider__content[aria-hidden], .logo-slider__items[aria-hidden]')) continue;
        if (observed.indexOf(card) === -1) { observed.push(card); observer.observe(card); }
        var rect = card.getBoundingClientRect();
        var visible = Math.min(rect.right, right) > Math.max(rect.left, left) && Math.min(rect.bottom, bottom) > Math.max(rect.top, top);
        if (visible || (document.activeElement && card.contains(document.activeElement))) {
          if (card.hasAttribute('aria-hidden')) card.removeAttribute('aria-hidden');
          if (card.hasAttribute('inert')) card.removeAttribute('inert');
        } else {
          if (card.getAttribute('aria-hidden') !== 'true') card.setAttribute('aria-hidden', 'true');
          if (!card.hasAttribute('inert')) card.setAttribute('inert', '');
        }
      }
    }
    var observer = new IntersectionObserver(sync, { root: root, threshold: 0 });
    // At an exact edge threshold 0 may report a zero-area intersection. Scroll and motion frames
    // reconcile positive overlap, so an entering card is restored without waiting for another crossing.
    function tick() {
      frame = 0;
      sync();
      if (!root.isConnected) return;
      if (Date.now() < until) frame = window.requestAnimationFrame(tick);
    }
    function moving() { until = Date.now() + 850; if (!frame) frame = window.requestAnimationFrame(tick); }
    var changes = new MutationObserver(function () { sync(); if (motion) moving(); });
    changes.observe(root, { childList: true, subtree: true });
    root.addEventListener('scroll', sync, { passive: true });
    function resized() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { resizeTimer = 0; sync(); }, 100);
    }
    function focusLeft() {
      window.clearTimeout(focusTimer);
      focusTimer = window.setTimeout(function () { focusTimer = 0; sync(); }, 0);
    }
    root.addEventListener('focusout', focusLeft);
    window.addEventListener('resize', resized, { passive: true });
    if (window.ResizeObserver) { sizeObserver = new window.ResizeObserver(resized); sizeObserver.observe(root); }
    if (motion) { motion.addEventListener('transitionrun', moving); motion.addEventListener('animationstart', moving); }
    function stop() {
      observer.disconnect(); changes.disconnect(); window.cancelAnimationFrame(frame);
      root.removeEventListener('scroll', sync);
      root.removeEventListener('focusout', focusLeft);
      window.removeEventListener('resize', resized);
      window.clearTimeout(resizeTimer); window.clearTimeout(focusTimer);
      if (sizeObserver) sizeObserver.disconnect();
      if (motion) { motion.removeEventListener('transitionrun', moving); motion.removeEventListener('animationstart', moving); }
    }
    sync();
    if (motion) moving();
    return { sync: sync, stop: stop };
  }
  function bindSize(widget) {
    var sc = widget.querySelector('.stamped-carousel-scroll') || widget;
    if (widget.jcSizeTarget === sc) return;
    if (widget.jcSizeObs) widget.jcSizeObs.disconnect();
    widget.jcSizeTarget = sc;
    if (widget.jcVisibility) widget.jcVisibility.stop();
    widget.jcVisibility = sc === widget ? null : jcVisibleCards(sc, '.stamped-carousel-scroll-wrapper > div.block', null);
    if (!window.ResizeObserver) return;
    widget.jcSizeObs = new ResizeObserver(function (entries) {
      var nw = Math.round(entries[0].contentRect.width);
      if (nw === widget.jcKnownW) return;
      var first = widget.jcKnownW == null;
      widget.jcKnownW = nw;
      if (!first) remeasure();
    });
    widget.jcSizeObs.observe(sc);
  }
  function release(widget) {
    if (!widget || alive(widget)) return;
    if (!widget.jcCarouselWatch && !widget.jcCarouselObs && !widget.jcSizeObs && !widget.jcRetry) return;
    if (widget.jcCarouselObs) { widget.jcCarouselObs.disconnect(); widget.jcCarouselObs = null; }
    if (widget.jcSizeObs) { widget.jcSizeObs.disconnect(); widget.jcSizeObs = null; }
    if (widget.jcVisibility) { widget.jcVisibility.stop(); widget.jcVisibility = null; }
    widget.jcSizeTarget = null;
    widget.jcKnownW = null;
    if (widget.jcRetry) { clearTimeout(widget.jcRetry); widget.jcRetry = 0; }
    widget.jcLayoutTries = 0;
    widget.jcCarouselWatch = false;
    for (var i = pending.length - 1; i >= 0; i--) if (pending[i].w === widget) pending.splice(i, 1);
    for (var k = watched.length - 1; k >= 0; k--) if (watched[k] === widget) watched.splice(k, 1);
  }
  function pass(widget, cards) {
    if (!alive(widget)) { release(widget); return; }
    widget.jcPasses = (widget.jcPasses || 0) + 1;
    bindSize(widget);
    var list = cards;
    if (!list) list = widget.querySelectorAll('.block');
    else {
      var live = [];
      for (var i = 0; i < cards.length; i++) if (alive(cards[i]) && widget.contains(cards[i])) live.push(cards[i]);
      list = live;
    }
    for (var t = 0; t < list.length; t++) {
      var empties = list[t].querySelectorAll('.stamped-reviews-title a');
      for (var k = 0; k < empties.length; k++) emptyTitle(empties[k]);
    }
    viewAll(widget);
    for (var c = 0; c < list.length; c++) card(list[c]);
    var retry = expandAll(list);
    // A card measured before it had a width would cache "not clamped". Retry a few times, then wait for a real change.
    if (widget.jcRetry) { clearTimeout(widget.jcRetry); widget.jcRetry = 0; }
    if (retry) {
      widget.jcLayoutTries = (widget.jcLayoutTries || 0) + 1;
      if (widget.jcLayoutTries <= 8) widget.jcRetry = setTimeout(function () {
        widget.jcRetry = 0;
        if (!alive(widget)) { release(widget); return; }
        schedule(widget, null);
      }, 250);
    } else widget.jcLayoutTries = 0;
  }
  // JC-EVO 10/06/2026 (Eric: Lighthouse speed, no visible change): same 100ms leading coalesce as before
  // (the timer is not reset). Records that arrive during the wait are kept, then applied together.
  function schedule(widget, cards) {
    var slot = null;
    for (var i = 0; i < pending.length; i++) if (pending[i].w === widget) { slot = pending[i]; break; }
    if (!slot) pending.push(slot = { w: widget, cards: cards });
    else if (!slot.cards || !cards) slot.cards = null;
    else for (var j = 0; j < cards.length; j++) if (slot.cards.indexOf(cards[j]) === -1) slot.cards.push(cards[j]);
    if (timer) return;
    timer = setTimeout(function () {
      timer = 0;
      var batch = pending;
      pending = [];
      for (var i = 0; i < batch.length; i++) pass(batch[i].w, batch[i].cards);
    }, 100);
  }
  function clearCard(card) {
    card.jcMeasureKey = '';
    card.jcMeasureBlock = null;
    card.jcMeasureBtn = 0;
  }
  function forgetMessage(widget, node) {
    var el = node && node.nodeType === 3 ? node.parentNode : node;
    if (!el || !el.closest) return;
    var msg = el.matches && el.matches('.stamped-reviews-message') ? el : el.closest('.stamped-reviews-message');
    // JC-EVO 10/06/2026 (Eric: Lighthouse speed, no visible change): same text with new breaks still changes overflow.
    if (!msg || !widget.contains(msg)) return;
    var card = msg.closest('.block');
    if (card) card.jcMeasureKey = '';
  }
  function onMut(widget, recs) {
    if (!alive(widget)) { release(widget); return; }
    var full = false, list = [];
    function add(el) { if (el && list.indexOf(el) === -1) list.push(el); }
    for (var i = 0; i < recs.length; i++) {
      var rec = recs[i];
      if (rec.type === 'attributes') {
        var a = rec.target;
        // Product-link mapper rewrites only these hrefs, often after this pass already built the review link.
        if (a && a.matches && a.matches('.stamped-reviews-product-title a, .stamped-reviews-image a')) {
          var hostA = a.closest && a.closest('.block');
          if (hostA && widget.contains(hostA)) add(hostA);
        }
        continue;
      }
      forgetMessage(widget, rec.target);
      var gone = rec.removedNodes;
      for (var g = 0; g < gone.length; g++) forgetMessage(widget, gone[g]);
      var nodes = rec.addedNodes;
      for (var j = 0; j < nodes.length; j++) forgetMessage(widget, nodes[j]);
      var t = rec.target;
      if (t && t.nodeType === 3) t = t.parentNode;
      var host = t && t.closest ? t.closest('.block') : null;
      if (host && widget.contains(host)) add(host); else full = true;
      for (var j2 = 0; j2 < nodes.length; j2++) {
        var n = nodes[j2];
        if (!n || n.nodeType !== 1) continue;
        // JC-EVO 10/06/2026 (Eric: Lighthouse speed, no visible change): a card removed and put back
        // keeps its measurement key, and the widget is still watched so watch() does not clear it.
        // Same text with new breaks, or a new width, would then skip scrollHeight. Clear added cards
        // and cards inside an added wrapper before this pass. Nodes we insert under a card are not cards.
        if (n.matches && n.matches('.block')) { clearCard(n); add(n); }
        else if (n.closest && n.closest('.block')) add(n.closest('.block'));
        else full = true;
        if (n.querySelectorAll) {
          var inner = n.querySelectorAll('.block');
          for (var k = 0; k < inner.length; k++) { clearCard(inner[k]); add(inner[k]); }
        }
      }
    }
    if (!full && !list.length) return;
    schedule(widget, full ? null : list);
  }
  function watch(widget) {
    if (!widget || widget.jcCarouselWatch || !alive(widget)) return;
    widget.jcCarouselWatch = true;
    // JC-EVO 10/06/2026 (Eric: Lighthouse speed, no visible change): a reinserted root keeps its old
    // measurement keys, and the new ResizeObserver's first callback does not remeasure. Drop them
    // before the first pass so overflow is read at the width and markup the root has now.
    var stale = widget.querySelectorAll('.block');
    for (var c = 0; c < stale.length; c++) clearCard(stale[c]);
    widget.jcCarouselObs = new MutationObserver(function (recs) { onMut(widget, recs); });
    widget.jcCarouselObs.observe(widget, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['href']
    });
    watched.push(widget);
    schedule(widget, null);
  }
  function releaseTree(n) {
    if (!n || n.nodeType !== 1) return;
    if (n.matches && n.matches(WIDGET)) { if (!alive(n)) release(n); return; }
    if (!n.querySelectorAll) return;
    var found = n.querySelectorAll(WIDGET);
    for (var k = 0; k < found.length; k++) if (!alive(found[k])) release(found[k]);
  }
  // JC-EVO 10/06/2026 (Eric: Lighthouse speed, no visible change): find carousel roots only. Card work stays on
  // a per-widget observer, so the rest of the page no longer flushes layout through this script.
  function discover(recs) {
    for (var i = 0; i < recs.length; i++) {
      var gone = recs[i].removedNodes;
      for (var r = 0; r < gone.length; r++) releaseTree(gone[r]);
      var nodes = recs[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (!n || n.nodeType !== 1) continue;
        if (n.matches && n.matches(WIDGET)) { watch(n); continue; }
        if (!n.childElementCount) continue;
        if (n.closest && n.closest(WIDGET)) continue;
        if (!n.querySelectorAll) continue;
        var found = n.querySelectorAll(WIDGET);
        for (var k = 0; k < found.length; k++) watch(found[k]);
      }
    }
    for (var w = watched.length - 1; w >= 0; w--) if (!alive(watched[w])) release(watched[w]);
  }
  if (!document.querySelector(WIDGET)) return;

  // Arrows: Stamped pages the row by setting `left` on an absolutely positioned wrapper, which does not fit the
  // theme's card layout. Handle the click first (capture phase) and scroll the row natively instead; wrap at the ends.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#stamped-reviews-widget[data-widget-type="carousel"] .stamped-carousel-button-left, #stamped-reviews-widget[data-widget-type="carousel"] .stamped-carousel-button-right');
    if (!btn) return;
    e.stopPropagation();
    e.preventDefault();
    var w = btn.closest('#stamped-reviews-widget');
    var sc = w.querySelector('.stamped-carousel-scroll');
    var cardEl = w.querySelector('.stamped-carousel-scroll-wrapper > .block');
    if (!sc || !cardEl) return;
    var gap = parseFloat(getComputedStyle(cardEl.parentElement).columnGap) || 0;
    var step = cardEl.getBoundingClientRect().width + gap;
    var page = step * Math.max(1, Math.floor((sc.clientWidth + gap) / step));
    var dir = btn.classList.contains('stamped-carousel-button-left') ? -1 : 1;
    var max = sc.scrollWidth - sc.clientWidth;
    var target = sc.scrollLeft + dir * page;
    var wrap = (dir > 0 && sc.scrollLeft >= max - 4) || (dir < 0 && sc.scrollLeft <= 4);
    if (wrap) target = dir > 0 ? 0 : max;
    sc.scrollTo({ left: target, behavior: wrap ? 'instant' : 'smooth' }); // wrap jumps, paging glides
  }, true);
  var roots = document.querySelectorAll(WIDGET);
  for (var ri = 0; ri < roots.length; ri++) watch(roots[ri]);
  new MutationObserver(discover).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(WIDGET)) watch(root);
    var more = root.querySelectorAll(WIDGET);
    for (var si = 0; si < more.length; si++) watch(more[si]);
  });
})();

/* JC-EVO 10/09/2026 (Eric, option B): one combined review count under the RKIN Reviews title.
   Replaces the 09/25 pill counts. One Stamped batch call sums full-page and full-page-nps.
   Stars and the total render once, directly after the main-section h1. Pills stay labels only.
   The jc-tabrate-on class hides Stamped's own rating line while that combined line is present.
   A failed or partial response shows nothing, sets no class, and does not retry. */
(function () {
  var w = document.querySelector('#stamped-reviews-widget[data-widget-type^="full-page"]');
  if (!w) return;
  var h1 = document.querySelector('.shopify-section[id$="__main"] h1');
  if (!h1) return;
  var asked = false, timer = 0;
  var SUB = 'jc-rv-sub';
  function lineEl() { return document.querySelector('.' + SUB); }
  function spanish() {
    var lang = (document.documentElement && document.documentElement.lang) || '';
    return lang.indexOf('es') === 0;
  }
  function positiveInt(v) {
    var n = +v;
    return Number.isInteger(n) && n > 0;
  }
  function starSuffix(r, i) {
    return r >= i - 0.5 ? '' : r >= i - 0.7 ? '-half-o' : '-o';
  }
  function hold() {
    if (lineEl()) w.classList.add('jc-tabrate-on');
  }
  function idOf(x) {
    var v = x && x.elementId;
    return typeof v === 'number' || typeof v === 'string' ? String(v) : '';
  }
  // Exactly one product entry (elementId 0) and one site entry (elementId 1), either order; anything else shows nothing.
  function accept(d) {
    if (!Array.isArray(d) || d.length !== 2 || !d[0] || !d[1]) return null;
    var a = idOf(d[0]), b = idOf(d[1]);
    if (!((a === '0' && b === '1') || (a === '1' && b === '0'))) return null;
    var product = a === '0' ? d[0] : d[1], site = a === '0' ? d[1] : d[0];
    if (!positiveInt(product.totalAll) || !positiveInt(site.totalAll)) return null;
    return { total: (+product.totalAll) + (+site.totalAll), rating: +product.ratingAll };
  }
  function render(total, rating) {
    if (lineEl()) { hold(); return; }
    var es = spanish();
    var p = document.createElement('p');
    p.className = SUB;
    if (rating >= 1 && rating <= 5) {
      var stars = document.createElement('span');
      stars.className = 'jc-rv-sub__stars';
      stars.setAttribute('role', 'img');
      var shown = rating.toFixed(1);
      stars.setAttribute('aria-label', es ? shown.replace('.', ',') + ' de 5 estrellas' : shown + ' out of 5 stars');
      for (var i = 1; i <= 5; i++) {
        var icon = document.createElement('i');
        icon.className = 'stamped-fa stamped-fa-star' + starSuffix(rating, i);
        stars.appendChild(icon);
      }
      p.appendChild(stars);
    }
    var num = document.createElement('b');
    num.textContent = es ? String(total) : total.toLocaleString('en-US');
    p.appendChild(num);
    var label = document.createElement('span');
    label.textContent = es ? 'reseñas de clientes' : 'customer reviews';
    p.appendChild(label);
    h1.insertAdjacentElement('afterend', p);
    w.classList.add('jc-tabrate-on');
  }
  function ask() {
    if (asked) return;
    var g = window.StampedGlobalOptions;
    // sId is often empty on this page (10/09 QA); the batch endpoint answers with apiKey + storeUrl, so sId is sent as given.
    if (!g || !g.apiKey || !g.storeUrl || !window.fetch) return;
    asked = true;
    // elementId stays the strings '0' and '1'. A non-numeric id makes this endpoint return [].
    var body = { data: [
      { type: 'full-page', apiKey: g.apiKey, sId: g.sId || '', storeUrl: g.storeUrl, page: 1, skip: 1, elementId: '0' },
      { type: 'full-page-nps', apiKey: g.apiKey, sId: g.sId || '', storeUrl: g.storeUrl, page: 1, skip: 1, elementId: '1' }
    ] };
    window.fetch('https://stamped.io/api/widget/reviews/batch', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res || !res.ok) throw new Error('status');
      return res.json();
    }).then(function (d) {
      var parsed = accept(d);
      if (!parsed) return;
      render(parsed.total, parsed.rating);
    }).catch(function () {});
  }
  new MutationObserver(function () {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; if (!asked) ask(); hold(); }, 50);
  }).observe(w, { childList: true, subtree: true });
  ask();
})();

/* JC-EVO 09/25/2026: product page review cards end with the product like the review carousel cards: small white
   product photo + name, linking to the product (from the review widget's data-name / data-url / data-image-url).
   Stamped hides its own product line on single-product pages and redraws the list when paging or filtering, so a
   light observer adds the row to new cards. */
(function () {
  var m = document.getElementById('stamped-main-widget');
  if (!m) return;
  var name = m.getAttribute('data-name') || m.getAttribute('data-product-title');
  var url = m.getAttribute('data-url');
  var img = m.getAttribute('data-image-url');
  if (!name) return;
  if (img && img.indexOf('//') === 0) img = 'https:' + img;
  if (img) img = img.replace(/%3F/gi, '?').replace(/%3D/gi, '=').replace(/%26/gi, '&');
  if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  function add() {
    var cards = m.querySelectorAll('.stamped-reviews > .stamped-review');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].querySelector(':scope > .jc-review-product')) continue;
      var row = document.createElement(url ? 'a' : 'div');
      row.className = 'jc-review-product';
      if (url) row.href = url;
      if (img) {
        var box = document.createElement('span');
        box.className = 'jc-review-product-img';
        var im = document.createElement('img');
        im.src = img; im.alt = ''; im.loading = 'lazy';
        box.appendChild(im); row.appendChild(box);
      }
      var t = document.createElement('span');
      t.className = 'jc-review-product-name';
      t.textContent = name;
      row.appendChild(t);
      cards[i].appendChild(row);
      var au = cards[i].querySelector('.stamped-review-header > .author');
      var vb = cards[i].querySelector('.stamped-review-header > .stamped-verified-badge');
      if (au && vb) au.appendChild(vb);
    }
  }
  var timer = 0;
  new MutationObserver(function () {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; add(); }, 50);
  }).observe(m, { childList: true, subtree: true });
  add();
})();

/* JC-EVO 09/25/2026: reviews summary design B: prev/next buttons for the product page Customer Photos strip.
   custom-theme.css turns Stamped's photo row into a horizontal scroller (every customer photo). Mouse users get two real
   buttons at the right of the "Customer Photos" title: they page the row by the photos in view, are disabled at the
   ends and hidden when every photo fits; custom-theme.css hides them on phones and touch screens, which swipe. Stamped
   renders the summary after load and can redraw it, so a light observer adds the buttons again. The photos are not
   moved or cloned: Stamped's lightbox (inline onclick on each photo) is unchanged. */
(function () {
  var m = document.getElementById('stamped-main-widget');
  if (!m) return;
  var ICON = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M9 2.5 4.5 7 9 11.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function update(nav, sc) {
    var max = sc.scrollWidth - sc.clientWidth, b = nav.querySelectorAll('button');
    nav.hidden = max <= 1;
    b[0].disabled = sc.scrollLeft <= 1;
    b[1].disabled = sc.scrollLeft >= max - 1;
  }
  function go(sc, dir) {
    var tile = sc.querySelector('.stamped-photo');
    if (!tile) return;
    var gap = parseFloat(getComputedStyle(sc).columnGap) || 0;
    var step = tile.getBoundingClientRect().width + gap;
    var page = step * Math.max(1, Math.floor((sc.clientWidth + gap) / step));
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sc.scrollBy({ left: dir * page, behavior: calm ? 'instant' : 'smooth' });
  }
  function add() {
    var box = m.querySelector('.stamped-summary .stamped-summary-photos');
    var sc = box && box.querySelector('.stamped-photos-carousel > div');
    if (!sc || !sc.querySelector('.stamped-photo')) return;
    // JC-EVO 09/30/2026 a11y (WCAG 2.1.1, audit S2): the photo row scrolled by swipe or the mouse buttons only (hidden on phones and
    // touch screens). The row itself becomes a focusable, labelled region, so the arrow keys scroll it.
    // (each attribute is reconciled on every pass, so a Stamped redraw or a vendor tabindex does not leave it half set)
    if (!sc.hasAttribute('tabindex') || sc.getAttribute('tabindex') === '-1') sc.setAttribute('tabindex', '0');
    if (!sc.getAttribute('role')) sc.setAttribute('role', 'region');
    if (!sc.getAttribute('aria-label') && !sc.getAttribute('aria-labelledby')) {
      var head = box.querySelector('.stamped-summary-photos-title, .stamped-summary-photos-heading, h3, h4');
      sc.setAttribute('aria-label', (head && head.textContent.trim()) || 'Customer photos');
    }
    var nav = box.querySelector(':scope > .jc-photo-nav');
    if (nav && nav.jcStrip === sc) { update(nav, sc); return; }
    if (nav) nav.parentNode.removeChild(nav);
    nav = document.createElement('div');
    nav.className = 'jc-photo-nav';
    nav.jcStrip = sc;
    [['Previous customer photos', -1], ['Next customer photos', 1]].forEach(function (b) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', b[0]);
      btn.innerHTML = b[1] < 0 ? ICON : ICON.replace('<svg ', '<svg style="transform:scaleX(-1)" ');
      btn.addEventListener('click', function () { go(sc, b[1]); });
      nav.appendChild(btn);
    });
    box.appendChild(nav);
    if (!sc.jcNav) {
      sc.jcNav = true;
      var busy = 0;
      var later = function () {
        if (busy) return;
        busy = requestAnimationFrame(function () { busy = 0; var n = box.querySelector(':scope > .jc-photo-nav'); if (n) update(n, sc); });
      };
      sc.addEventListener('scroll', later, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(later).observe(sc);
      else window.addEventListener('resize', later);
    }
    update(nav, sc);
  }
  var timer = 0;
  new MutationObserver(function () {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; add(); }, 50);
  }).observe(m, { childList: true, subtree: true });
  add();
})();
/* /JC-EVO 09/25/2026: reviews summary design B */

/* JC-EVO 09/25/2026: reviews controls design B: keep the chosen keyword chip marked. Stamped redraws the product page chip
   list after a chip is chosen and the new list does not say which one is on (only its Clear filter button shows). The chip
   clicked (or chosen by Enter/Space) is remembered and marked .jc-chip-on (blue pill, custom-theme.css) while Clear filter
   is showing; Clear filter forgets it. Stamped's own handlers are untouched (listeners only read the click). */
(function () {
  var m = document.getElementById('stamped-main-widget');
  if (!m) return;
  var picked = null, timer = 0;
  function key(li) { return li.getAttribute('aria-label') || li.textContent.trim(); }
  function mark() {
    var clr = m.querySelector('#stamped-reviews-filter .stamped-summary-actions-clear');
    var on = picked && clr && clr.getClientRects().length > 0;
    var lis = m.querySelectorAll('.stamped-summary-keywords-list li');
    for (var i = 0; i < lis.length; i++) {
      var hit = !!on && key(lis[i]) === picked;
      if (lis[i].classList.contains('jc-chip-on') !== hit) lis[i].classList.toggle('jc-chip-on', hit);
    }
  }
  function note(e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest ? e.target.closest('#stamped-reviews-filter .stamped-summary-keywords-list li, #stamped-reviews-filter .stamped-summary-actions-clear') : null;
    if (!t || !m.contains(t)) return;
    picked = t.classList.contains('stamped-summary-actions-clear') ? null : key(t);
  }
  m.addEventListener('click', note, true);
  m.addEventListener('keydown', note, true);
  new MutationObserver(function () {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; mark(); }, 50);
  }).observe(m, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
})();
/* /JC-EVO 09/25/2026: reviews controls design B */

/* JC-EVO 09/26/2026: review product references link directly to their exact Shopify product ID's canonical handle.
   Catalog snapshot 09/26/2026 (published Online Store products only); refresh this map when adding new products.
   10/01/2026: REVIEW_PRODUCTS 165341696 (Kathleen S.) -> 7958280208622 (U1-W) and 165334671 (Holly B.) -> 611174481967
   (AlcaPure ZIP filters kit), per Stamped's public widget API productId; both were mis-snapshotted as navidium-shipping-protection.
   Review headings, Read more, helpful votes, sorting and Stamped's event handlers are unchanged. Unknown/deleted/site-only
   product references retain their image/text without a fabricated or broken redirect. No runtime catalog API or click interception. */
(function () {
  'use strict';
  /* JC-EVO 10/12/2026 RC21 p4 (rebuilt AH-14 products): retain archived IDs for historical reviews. */
  var PRODUCTS = {"1018477379631":"/products/quick-connect-fitting","1050927431727":"/products/zero-installation-purifier-wire-harness","1060672372783":"/products/pump-up-8000","1320789016623":"/products/onlisoft-pro-salt-free-whole-house-water-treatment-system","1350184796207":"/products/onlisoft-pro-replacement-carbon-media","1353202532399":"/products/rkin-op1l-certified-whole-house-lead-and-cyst-removal-system","1374508744751":"/products/op1l-lead-cyst-pfoa-and-pfos-replacement-cartridge","1391543320623":"/products/misting-system-copper-nozzles","1395495632943":"/products/onlipure-edition-zero-installation-purifier-replacement-filters-bundle","4096403898415":"/products/super-flex-installation-kit","4365659504707":"/products/cbs-onlisoft-pro-salt-free-whole-house-water-treatment-system","4368493117507":"/products/super-flex-installation-kit-for-rkin-cbs-whole-house-water-treatment-systems","4368531718211":"/products/rkin-flash-undersink-reverse-osmosis-system","4377913524291":"/products/cbs-dual-carbon-whole-house-water-treatment-system","4377926533187":"/products/cbs-pph-whole-house-combo-salt-free-water-softener-alternative-anti-scale-system-with-dual-carbon-filtration","4378265321539":"/products/cbs-carbon-replacement-cartridge","4378323746883":"/products/cbs-onlisoft-whole-house-salt-free-water-softener","4378324697155":"/products/cbs-pph-salt-free-water-softener","4378332856387":"/products/dragon-self-cleaning-90-micron-sediment-filter","4386238857283":"/products/cbs-pph-replacement-cartridge","4489499770947":"/products/anti-scale-carbon-pre-filter","4489619505219":"/products/flash-replacement-filters-kit","4490269229123":"/products/onlipure-edition-zero-installation-purifier-ion-exchange-post-filter","4492414222403":"/products/90-micron-stainless-steel-screen-replacement-cartridge-for-dragon-self-cleaning-whole-house-filter","4492556664899":"/products/90-micron-stainless-steel-screen-replacement-cartridge-for-dragon-hot-self-cleaning-whole-house-filter","4530448105539":"/products/post-filter-mounting-clips","4545495236675":"/products/dual-function-tds-meter-for-tds-and-water-temp-measurements","4570441842755":"/products/rkin-carbon-block-filter-ft-series-ft-92","4570450821187":"/products/rkin-sediment-filter-pp5","6085591695534":"/products/rkin-whole-house-water-filter-system","611173466159":"/products/zip-pump","611173564463":"/products/1-year-extended-warranty-for-refurbished-zero-installation-purifier","611173859375":"/products/zero-installation-purifier-reverse-osmosis-alkaline-post-filter","611173957679":"/products/zero-installation-purifier-ac-adapter","611174055983":"/products/zero-installation-purifier-spout","611174154287":"/products/zero-installation-purifier-replacement-reverse-osmosis-membrane","611174481967":"/products/zero-installation-purifier-replacement-filters-bundle","611174678575":"/products/zip-flow-restrictor","611174842415":"/products/zip-bottom-tank-switch","6112290177198":"/products/whole-house-tank-jacket","623584968751":"/products/zero-installation-purifier-countertop-reverse-osmosis-water-filter","623585001519":"/products/zero-installation-purifier-pcb-board","623585099823":"/products/zero-installation-purifier-reverse-osmosis-countertop-water-filter-refurbished","623585198127":"/products/bottom-tank-gasket","623585394735":"/products/zip-solenoid","6323769606318":"/products/flash-undersink-reverse-osmosis-system-post-filter-replacement-cartridge","6336114491566":"/products/rkin-20-5-micron-pp-sediment-filter-for-whole-house-water-filtration","6336304119982":"/products/rkin-whole-house-well-water-filter-system-for-iron-sulfur-and-manganese-treatment","6339274866862":"/products/rkin-whole-house-salt-based-water-softener-system","6340887609518":"/products/whole-house-salt-free-water-softener-and-well-water-filter-combo","6341158633646":"/products/whole-house-salt-based-water-softener-and-well-water-filter-combo","6341250449582":"/products/rkin-whole-house-salt-free-water-softener","6341459312814":"/products/salt-based-water-softener-and-whole-house-carbon-filter-system","6575386230958":"/products/single-tank-super-flex-installation-kit-for-whole-house-water-treatment-system","6620850913454":"/products/copy-of-quick-connect-fitting","6621063610542":"/products/cbs-5-micron-sediment-whole-house-filter","6629026922670":"/products/o-ring-for-zee-pro-filter-housing","7440629661934":"/products/essential-city-water-test","7440632643822":"/products/advanced-city-water-test","7440634413294":"/products/essential-well-water-test","7440641163502":"/products/advanced-well-water-test","7440643686638":"/products/pfas-water-test","7440647618798":"/products/tannins-water-test","7440650633454":"/products/metals-and-minerals-water-test","7506233491694":"/products/alcapure-whole-house-filter-system-for-alkaline-ph","7618048622830":"/products/home-stainless-steel-ultraviolet-water-disinfection-system","7676856500462":"/products/uv-light-replacement-bulb","7676922921198":"/products/high-output-uv-light-system-replacement-quartz-sleeve","7876380754158":"/products/u1-2-year-filter-bundle","7876387963118":"/products/u1-turntable","7958280208622":"/products/u1-space-saving-4-in-1-water-filter-system","7958481207534":"/products/u1-extended-warranty","7986250481902":"/products/collet-for-quick-connect-fitting","7998166991086":"/products/quick-connect-fitting-elbow-3-8-inch-female-1-4-inch-female","8009088106734":"/products/u1-rkin-2-in-1-sediment-and-carbon-pre-filter-qt-series","8009091154158":"/products/u1-rkin-alcapure-alkaline-post-filter-qt-series","8009091875054":"/products/u1-rkin-200-gpd-encapsulated-reverse-osmosis-membrane-qt-series","8009092989166":"/products/u1-rkin-hydrogen-module","8018003198190":"/products/fitting-elbow-quick-connect-1-4-inch-female-1-4-inch-npt-thread-male","8041340371182":"/products/quick-connect-fitting-elbow-1-4-inch-female-to-1-4-inch-female","8115722879214":"/products/navidium-shipping-protection","8115870630126":"/products/navidium-shipping-protection-1","8115870662894":"/products/navidium-shipping-protection-2","8115870695662":"/products/navidium-shipping-protection-3","8117182038254":"/products/u1-filter-and-hydrogen-module-removal-tool","8182114386158":"/products/stainless-steel-tumbler","8182115926254":"/products/stainless-steel-tumbler-2","8182116319470":"/products/stainless-steel-tumbler-3","8182116385006":"/products/stainless-steel-tumbler-1","8182116679918":"/products/stainless-steel-tumbler-4","8182117204206":"/products/stainless-steel-water-bottle-1","8182118023406":"/products/stainless-steel-water-bottle-2","8182119334126":"/products/stainless-steel-water-bottle","8182119596270":"/products/stainless-steel-water-bottle-4","8182120317166":"/products/stainless-steel-water-bottle-5","8182124347630":"/products/short-sleeve-unisex-t-shirt-think-fast-1","8182125166830":"/products/short-sleeve-unisex-t-shirt-think-fast-2","8182125527278":"/products/short-sleeve-unisex-t-shirt-think-fast-3","8182125723886":"/products/short-sleeve-unisex-t-shirt-think-fast-4","8182125920494":"/products/short-sleeve-unisex-t-shirt-think-fast-5","8182126674158":"/products/short-sleeve-unisex-t-shirt-think-fast-6","8182126870766":"/products/short-sleeve-unisex-t-shirt-think-fast-7","8182127034606":"/products/short-sleeve-unisex-t-shirt","8190506664174":"/products/stainless-steel-tumbler-6","8190507155694":"/products/stainless-steel-water-bottle-6","8510977573102":"/products/check-valve-quick-connect-1-4-inch-female","855713972271":"/products/leather-filter-housing-wrench","8647227605230":"/products/single-tank-super-flex-installation-kit-for-whole-house-water-treatment-system-copy","8677161271534":"/products/replacement-filter-cartridge-for-rkin-ah-14-air-purifier","8677164155118":"/products/replacement-filter-cartridge-for-rkin-ah-14-pro-air-purifier","8719875768558":"/products/rkin-ah-14-ah-14-pro-hepa-14-air-purifiers-breathe-cleaner-healthier-air-with-uv-carbon-ion-technology","8720618553582":"/products/2-year-replacement-filter-cartridge-bundle-for-rkin-ah-14-air-purifier","8720618881262":"/products/2-year-replacement-filter-cartridge-bundle-for-rkin-ah-14-pro-air-purifier","8764740337902":"/products/certified-refurbished-u1-space-saving-4-in-1-water-filter-system","8821910372590":"/products/purified-spot-free-rinse-portable-reverse-osmosis-system","8832289472750":"/products/2-year-alcapure-edition-zero-installation-purifier-replacement-filter-bundle","8832306446574":"/products/2-year-onlipure-edition-zero-installation-purifier-replacement-filter-bundle","8882374803694":"/products/alcapure-zero-installation-purifier-with-complete-2-year-filter-pack","8882552209646":"/products/onlipure-zero-installation-purifier-with-complete-2-year-filter-pack","8883238830318":"/products/u1-supreme-3-year-bundle","8888145805550":"/products/whole-home-reverse-osmosis-system","8889900663022":"/products/ah-14-pro-air-purifier-3-year-bundle","8897420493038":"/products/flash-alcapure-3-year-bundle","8898374271214":"/products/advanced-water-softener-and-well-water-filter-combo","8898517467374":"/products/advanced-salt-free-water-conditioner-and-well-water-filter-combo","8908545556718":"/products/ac-adapter-for-rkin-cs-control-valve","8970881925358":"/products/u1-1-year-filter-bundle","8970891854062":"/products/1-year-replacement-filter-cartridge-bundle-for-rkin-ah-14-pro-air-purifier","8970892017902":"/products/1-year-replacement-filter-cartridge-bundle-for-rkin-ah-14-air-purifier","8986749173998":"/products/u1-float-with-cap","8986974453998":"/products/u1-replacement-nozzle","9052007137518":"/products/u1-drip-tray","9126394429678":"/products/super-flex-installation-kit-18x1-4-piece-set","9128608628974":"/products/super-flex-installation-kit-for-advanced-well-water-system","9199955083502":"/products/u1-replacement-pump","9248325239022":"/products/double-ah-14-pro-bundle","941440991279":"/products/bottom-tank-divider-with-a-funnel","9431429939438":"/products/sediment-filter-wrench","9491546439918":"/products/ban-t-citric-acid-resin-cleaner-ph-adjuster-4lbs","9574520586478":"/products/1-year-replacement-filter-cartridge-bundle-for-rkin-ah-14-air-purifier","9574520684782":"/products/1-year-replacement-filter-cartridge-bundle-for-rkin-ah-14-pro-air-purifier"};
  // Exact public Stamped review-ID/product-ID metadata snapshot; no title or historical image identity guessing.
  // Unknown future Shopify-image-only references stay inert; refresh this bounded lineage table with verified review metadata.
  var REVIEW_PRODUCTS = {"15399074":"0","158738191":"1320789016623","158964248":"1320789016623","159637916":"623584968751","160077882":"8764740337902","160084366":"7958280208622","160134326":"623584968751","161394602":"7958280208622","161499156":"7958280208622","161698136":"8898374271214","161751721":"623584968751","161804475":"623584968751","161819488":"623584968751","162149724":"7958280208622","162182625":"7958280208622","162333193":"1353202532399","162527291":"7958280208622","162527311":"7958280208622","162778553":"7958280208622","162927634":"4368531718211","163085148":"623584870447","163085156":"4368531718211","163165302":"4365659504707","163211038":"623584968751","163212009":"623584870447","163760020":"623584870447","163765879":"1","164020090":"4368531718211","164020637":"623584870447","164045504":"623584870447","164076246":"611174154287","164077953":"1","164085506":"6336114491566","164098682":"623584870447","164170960":"7958280208622","164174030":"623584968751","164881625":"1","164892454":"7958280208622","165334671":"611174481967","165341696":"7958280208622","165459819":"623584968751","165485235":"1","165485260":"1","165537179":"1353202532399","165541806":"7958280208622","165771963":"1","165779064":"1018477379631","165831190":"623584870447","165842270":"7958280208622","165890348":"1"};
  var ROOT = '#stamped-reviews-widget, #stamped-main-widget';
  var LINKS = '.stamped-reviews-image a, .stamped-reviews-product-title a, .stamped-products-reviews-title a.stamped-review-product, a.stamped-review-product, .stamped-review-product a, a.jc-review-product';
  var HOSTS = ['rkin.com', 'www.rkin.com', 'puricomusa.myshopify.com'];
  function productPath(href) {
    if (!href) return null;
    try {
      var u = new URL(href, location.origin);
      if (u.protocol !== 'https:' || u.username || u.password || HOSTS.indexOf(u.hostname) === -1) return null;
      if (!/^\/products\/[a-z0-9][a-z0-9-]*\/?$/.test(u.pathname)) return null;
      return { path: u.pathname.replace(/\/$/, ''), suffix: u.search + u.hash };
    } catch (_) { return null; }
  }
  function reviewProductId(card) {
    var found = null, conflict = false, dom = /^stamped-review-([1-9][0-9]*)$/.exec(card.id || '');
    function note(id) { if (found && found !== id) conflict = true; else found = id; }
    if (dom) note(dom[1]);
    var hints = card.querySelectorAll('.stamped-reviews-title a[href], a.stamped-review-title[href], a.jc-read-more[href], [data-jc-go]');
    for (var i = 0; i < hints.length; i++) {
      try {
        var u = new URL(hints[i].getAttribute('data-jc-go') || hints[i].getAttribute('href'), location.origin);
        if (u.protocol !== 'https:' || u.hostname !== 'stamped.io' || u.port || u.username || u.password || u.search || u.hash) continue;
        var token = /^\/go\/([A-Za-z0-9_-]+)$/.exec(u.pathname);
        if (!token) continue;
        var decoded = atob(token[1].replace(/-/g, '+').replace(/_/g, '/'));
        var id = /^w\|(WidgetCarousel|WidgetFullPage)\|52282\|r\|([1-9][0-9]*)\r$/.exec(decoded);
        if (id) note(id[2]);
      } catch (_) {}
    }
    if (conflict) return false; // never fall through to a canonical href when verified review hints contradict
    return found && Object.prototype.hasOwnProperty.call(REVIEW_PRODUCTS, found) ? REVIEW_PRODUCTS[found] : null;
  }
  function imageProductId(card) {
    var imgs = card.querySelectorAll('.stamped-reviews-image img'), found = null;
    for (var i = 0; i < imgs.length; i++) {
      var urls = [imgs[i].getAttribute('data-src'), imgs[i].getAttribute('src')];
      for (var j = 0; j < urls.length; j++) {
        if (!urls[j]) continue;
        try {
          var u = new URL(urls[j], location.origin);
          if (u.protocol !== 'https:' || u.hostname !== 'cdn1.stamped.io' || u.username || u.password) continue;
          var m = /^\/uploads\/productImages\/52282_([0-9]+)\.(?:jpe?g|png|gif|webp)$/i.exec(u.pathname);
          if (!m) continue;
          if (found && found !== m[1]) return null; // ambiguous image IDs are never guessed
          found = m[1];
        } catch (_) {}
      }
    }
    return found;
  }
  function productId(a, widget) {
    var card = a.closest('.block, .stamped-review-card, .stamped-review');
    if (!card || !widget.contains(card)) return null;
    var id = card.getAttribute('data-product-id');
    if (id && /^[0-9]+$/.test(id)) return id;
    if (widget.id === 'stamped-main-widget') {
      id = widget.getAttribute('data-product-id');
      if (id && /^[0-9]+$/.test(id)) return id;
    }
    var review = reviewProductId(card);
    return review !== null ? review : imageProductId(card);
  }
  // 10/03/2026 (Lighthouse crawlable-anchors): an <a> whose href was removed is no longer a link; role=none says so to
  // crawlers and assistive tech. data-jc-inert keeps the original role, restored when a real href comes back. Tab order
  // (tabindex / aria-hidden) stays with the empty-title logic above.
  function inert(a, on) {
    var was;
    if (on) {
      if (a.hasAttribute('href')) a.removeAttribute('href');
      if (!a.hasAttribute('data-jc-inert')) a.setAttribute('data-jc-inert', JSON.stringify(a.getAttribute('role')));
      if (a.getAttribute('role') !== 'none') a.setAttribute('role', 'none');
    } else if (a.hasAttribute('data-jc-inert')) {
      try { was = JSON.parse(a.getAttribute('data-jc-inert')); } catch (e) { was = null; }
      if (typeof was === 'string' && was) a.setAttribute('role', was); else a.removeAttribute('role');
      a.removeAttribute('data-jc-inert');
    }
  }
  function enhance(widget) {
    var links = widget.querySelectorAll(LINKS);
    for (var i = 0; i < links.length; i++) {
      var a = links[i], id = productId(a, widget), current = productPath(a.getAttribute('href'));
      if (id === false) { inert(a, true); continue; }
      var path = id ? PRODUCTS[id] : current && current.path;
      if (!path) {
        inert(a, true);
        continue;
      }
      var wanted = path + (current && current.path === path ? current.suffix : '');
      if (a.getAttribute('href') !== wanted) a.setAttribute('href', wanted);
      inert(a, false);
    }
  }
  function attach(widget) {
    if (widget.jcProductLinksObserved) return;
    widget.jcProductLinksObserved = true;
    var timer = 0;
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = 0; enhance(widget); }, 80);
    }).observe(widget, { childList: true, subtree: true }); // href changes do not retrigger this observer
    enhance(widget);
  }
  document.querySelectorAll(ROOT).forEach(attach);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.matches && e.target.matches(ROOT)) attach(e.target);
    e.target.querySelectorAll(ROOT).forEach(attach);
  });
})();
/* /JC-EVO 09/26/2026: review product references link directly */

/* JC-EVO 09/27/2026: arriving from a review card's "Read more" or title (#stamped-main-widget): Stamped draws the product's
   reviews after load, so the browser's own jump to the anchor finds nothing. Scroll there once the reviews exist. */
(function () {
  if (location.hash !== '#stamped-main-widget') return;
  var tries = 0, user = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { addEventListener(ev, function () { user = true; }, { once: true, passive: true }); });
  (function go() {
    var t = document.getElementById('stamped-main-widget');
    if (t && t.querySelector('.stamped-review')) {
      // content above keeps loading (images, sections), so keep the reviews at the top for a few seconds, never
      // fighting a visitor who has started scrolling
      var off = function () { return t.getBoundingClientRect().top - (parseFloat(getComputedStyle(t).scrollMarginTop) || 0); };
      var n = 0;
      (function hold() {
        if (user) return;
        if (Math.abs(off()) > 40) t.scrollIntoView({ block: 'start' });
        if (++n < 16) setTimeout(hold, 400);
      })();
      return;
    }
    if (++tries < 60) setTimeout(go, 250);
  })();
})();
/* JC-EVO 09/27/2026: RKIN Reviews page cards: group the product thumbnail and name into one row (.jc-card-product) so
   custom-theme.css can put it at the bottom of the card, under the RKIN reply. Stamped redraws the list when paging or
   switching tabs, so a light observer groups new cards. The nodes are moved, not copied: links and handlers stay. */
(function () {
  var w = document.querySelector('#stamped-reviews-widget[data-widget-type^="full-page"]');
  if (!w) return;
  var timer = 0;
  function group() {
    var cards = w.querySelectorAll('.stamped-review-card');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.querySelector(':scope > .jc-card-product')) continue;
      var img = c.querySelector(':scope > .stamped-reviews-image');
      var name = c.querySelector(':scope > .stamped-products-reviews-title');
      if (!img && !name) continue;
      var row = document.createElement('div');
      row.className = 'jc-card-product';
      if (img) row.appendChild(img);
      if (name) row.appendChild(name);
      c.appendChild(row);
    }
  }
  new MutationObserver(function () {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; group(); }, 50);
  }).observe(w, { childList: true, subtree: true });
  group();
})();

/* JC-EVO 09/27/2026: Horizon scrolls .page-wrapper and keeps <html> at overflow:hidden. Stamped's full-page
   widget tab switch ("Site Reviews") scrolls the WINDOW to the widget, which shifts the whole page up inside
   the locked viewport and leaves a blank band at the bottom (the page looks frozen). Hand any root scroll
   over to .page-wrapper instead. Inert on pages where .page-wrapper is not the scroll container. */
(function () {
  var root = document.scrollingElement || document.documentElement;
  function wrapper() {
    var pw = document.querySelector('.page-wrapper');
    return pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) ? pw : null;
  }
  window.addEventListener('scroll', function () {
    var y = root.scrollTop;
    if (y <= 0) return;
    var pw = wrapper();
    if (!pw) return;
    root.scrollTop = 0;
    pw.scrollTop += y;
  }, { passive: true });
})();

/* JC-EVO 09/27/2026 (Eric: "Link is broken on reviews"): on the RKIN Reviews page, Stamped's review-title link
   (stamped.io/go/…) returns 404. A title now opens the reviewed product's page at its reviews (#stamped-main-widget)
   when the card links to a product; otherwise (site reviews, removed products) it is plain text. The original link is
   kept in data-jc-go (the product-link script above reads the review ID from it). Re-evaluated on every widget render,
   so a card whose product link arrives later still gets a working title. */
(function () {
  var W = '#stamped-reviews-widget[data-widget-type^="full-page"]';
  var GO = /^https:\/\/stamped\.io\/go\//;
  function fix() {
    var ts = document.querySelectorAll(W + ' .stamped-reviews-title > .stamped-review-title');
    for (var i = 0; i < ts.length; i++) {
      var t = ts[i];
      var go = t.getAttribute('data-jc-go') || (GO.test(t.getAttribute('href') || '') ? t.getAttribute('href') : null);
      if (!go) continue;
      var card = t.closest('[id^="stamped-review-"]') || t.closest('.stamped-review-card');
      var prod = card && card.querySelector('a[href^="/products/"]:not(.stamped-review-title)');
      var want = prod ? prod.getAttribute('href').split('#')[0] + '#stamped-main-widget' : null;
      if (want) {
        if (t.tagName === 'A') { if (t.getAttribute('href') !== want) t.setAttribute('href', want); t.setAttribute('data-jc-go', go); continue; }
        var a = document.createElement('a');
        a.className = 'stamped-review-title stamped-style-color-link';
        a.href = want; a.textContent = t.textContent; a.setAttribute('data-jc-go', go);
        t.replaceWith(a);
      } else if (t.tagName === 'A') {
        var s = document.createElement('span');
        s.className = 'stamped-review-title';
        s.textContent = t.textContent; s.setAttribute('data-jc-go', go);
        t.replaceWith(s);
      }
    }
  }
  var timer = 0;
  new MutationObserver(function () {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; fix(); }, 250);
  }).observe(document.body, { childList: true, subtree: true });
  fix();
})();
